<template>
    <div class="center-page">
        <div class="page-head">
            <el-form inline label-width="80px" label-position="right">
                <el-form-item label="订单类型">
                    <el-select v-model="searchForm.type">
                        <el-option v-for="item in typeList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="searchForm.type===2" label="订单状态">
                    <el-select v-model="searchForm.order_state">
                        <el-option v-for="item in houseStateList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-else label="订单状态">
                    <el-select v-model="searchForm.order_state">
                        <el-option v-for="item in stateList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="margin-top: 40px;">
                    <el-button type="primary" :loading="loading" @click="handSearch">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="mt-20">
            <template v-if="currentType===1">
                <OrderShuttle v-for="(item,index) in list" @cancel="cancelShow(item,1)" :key="index" :item="item"></OrderShuttle>
            </template>
            <template v-if="currentType===2">
                <OrderHouse v-for="(item,index) in list" :key="index" @cancel="cancelShow(item,2)" @evaluate="evaluateShow(item)" :item="item"></OrderHouse>
            </template>
            <el-alert v-if="list.length<=0" title="暂无相关订单~" center :closable="false" type="warning" show-icon></el-alert>
        </div>

        <el-dialog :visible.sync="showEvaluate" title="评价">
            <el-form label-width="120px" label-position="right">
                <strong class="f-16 ml-a mr-a">房源：{{currentObj.title_true}}</strong>
                <el-form-item label="房源评价："><el-rate style="margin-top: 10px;" v-model="form.star_one" show-text></el-rate></el-form-item>
                <el-form-item label="准确性："><el-rate style="margin-top: 10px;" v-model="form.star_two" show-text></el-rate></el-form-item>
                <el-form-item label="清洁度："><el-rate style="margin-top: 10px;" v-model="form.star_three" show-text></el-rate></el-form-item>
                <el-form-item label="位置："><el-rate style="margin-top: 10px;" v-model="form.star_four" show-text></el-rate></el-form-item>
                <el-form-item label="性价比："><el-rate style="margin-top: 10px;" v-model="form.star_five" show-text></el-rate></el-form-item>
                <el-form-item label="评价留言：">
                    <el-input type="textarea"
                              v-model="form.assess_house"
                              placeholder="请输入入住规则"
                              :autosize="{ minRows: 4, maxRows: 8}"
                              maxlength="1000" show-word-limit></el-input>
                </el-form-item>
                <strong class="f-16 ml-a mr-a">房东：{{currentObj.driver_nickname}}</strong>
                <el-form-item label="房东评价："><el-rate style="margin-top: 10px;" v-model="form.star" show-text></el-rate></el-form-item>
                <el-form-item label="评价留言：">
                    <el-input type="textarea"
                              v-model="form.assess_user"
                              placeholder="请输入入住规则"
                              :autosize="{ minRows: 4, maxRows: 8}"
                              maxlength="1000" show-word-limit></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitEvaluate">确认评价</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :visible.sync="showCancel" title="取消订单">
            <el-form label-position="right" label-width="120px">
                <el-form-item label="取消原因">
                    <el-select v-model="reason">
                        <el-option v-for="(item,index) in cancelList" :label="item.name" :key="index" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="reason==='其它'" label="其它原因：">
                    <el-input type="textarea"
                              v-model="reasonOther"
                              placeholder="请输入入住规则"
                              :autosize="{ minRows: 4, maxRows: 8}"
                              maxlength="1000" show-word-limit></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-if="cancelType===1" @click="userBackMoney">确认取消</el-button>
                    <el-button type="primary" v-if="cancelType===2" @click="orderLandlordCancel">确认取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import OrderShuttle from "../../components/OrderShuttle";
    import OrderHouse from "../../components/OrderHouse";
    export default {
        name: "myOrder",
        components:{OrderShuttle, OrderHouse},
        data() {
            return {
                showEvaluate: false,
                showCancel: false,
                typeList: [
                    {id: 1, name: '接送机订单'},
                    {id: 2, name: '房源订单'},
                    {id: 3, name: '实惠之旅'}
                ],
                houseStateList: [
                    {id: 2, name: '待支付'},
                    {id: 1, name: '待确定'},
                    {id: 3, name: '待完成'},
                    {id: 4, name: '已完成'},
                    {id: 5, name: '已评价'}
                ],
                stateList: [
                    {id: 1, name: '待支付'},
                    {id: 2, name: '待确定'},
                    {id: 3, name: '待完成'},
                    {id: 4, name: '已完成'},
                    {id: 5, name: '已评价'}
                ],
                searchForm:{
                    type: 1,
                    order_state: 1
                },
                list: [],
                loading: false,
                currentType: 1,
                currentObj:{},
                form:{
                    star_one: 5,
                    star_two: 5,
                    star_three: 5,
                    star_four: 5,
                    star_five: 5,
                    star: 5,
                    order_id: '',
                    assess_house: '',
                    assess_user: ''
                },
                reason: '',
                reasonOther: '',
                cancelType: '',
                cancelList:[
                    {id :1, name: '日程改变'},
                    {id :2, name: '其它app便宜'},
                    {id :3, name: '亲人反对'},
                    {id :4, name: '服务不到位'},
                    {id :5, name: '其它'},
                ]
            }
        },
        created() {
            this.userTrackAll();
        },
        methods: {
            handSearch(){
                this.currentType = this.searchForm.type
                this.userTrackAll();
            },
            async userTrackAll() {
                this.loading = true;
                let [e, data] = await this.$api.userTrackAllApi(this.searchForm);
                this.loading = false;
                if(data.code === 200){
                    this.list = data.result;
                }
            },
            evaluateShow(item){
                this.currentObj = item;
                this.form.order_id = item.id
                this.showEvaluate = true;
            },
            cancelShow(item, type){
                this.cancelType = type;
                this.currentObj = item;
                this.showCancel = true;
            },
            async submitEvaluate(){
                let [e, data] = await this.$api.evaluateApi(this.form)
                console.log(data);
                if(data.code === 200 && data.status){
                    this.userTrackAll();
                    this.$message.success('评价成功')
                    this.showEvaluate = false;
                }else{
                    this.$message.warning('评价失败')
                }
            },
            async orderLandlordCancel(){
                let cancel_reason = this.reason;
                if(cancel_reason === '其它'){
                    cancel_reason = this.reasonOther
                }
                let [e, data] = await this.$api.orderLandlordCancelApi({
                    cancel_reason,order_id: this.currentObj.id
                })
                if(data.code === 200 && data.status){
                    this.userTrackAll();
                    this.$message.success('取消成功')
                    this.showCancel = false;
                }else{
                    this.$message.warning('取消失败')
                }
            },
            async userBackMoney(){
                let text = this.reason;
                if(text === '其它'){
                    text = this.reasonOther
                }
                let [e, data] = await this.$api.userBackMoneyApi({
                    text,out_trado_no: this.currentObj.out_trado_no
                })
                if(data.code === 200 && data.status){
                    this.userTrackAll();
                    this.$message.success('取消成功')
                    this.showCancel = false;
                }else{
                    this.$message.warning('取消失败')
                }
            }
        },
    }
</script>

<style scoped lang="less">
    .page-head{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px solid #e2e2e2;
    }
</style>
